<native-ads-client-form [formModel]="loadedModel"></native-ads-client-form>
<div class="container mt-4" *ngIf="loadingID">
    <native-ads-ads-report [clientID]="+loadingID"></native-ads-ads-report>
</div>
